import { useState, useRef, useEffect } from "react"
import {
  SubmitBtn,
  ActionSection,
  ScrollableContent,
  SideCancelBtn,
  ModalHeader,
} from "../Styles/InputStyles"
import { toast } from "react-toastify"
import { MdClose } from "react-icons/md"
import tw from "tailwind-styled-components"
import "react-dropdown/style.css"

const FilterModalForInActive = ({
  selectedData,
  onApplyFilter,
  handleClose,
  currentFilter = "",
  handleClearFilters,
}) => {

  const [selectedFilter, setSelectedFilter] = useState(null);
  const [height, setHeight] = useState(window.innerHeight)

  const filterGroups = [
    {
      title: "Refund Status",
      type: "refund",
      options: [
        { value: "ERD", label: "Refund Done" },
        { value: "EPR", label: "Refund Pending" },
      ],
    },
    {
      title: "Full & Final",
      type: "fullandfinal",
      options: [
        { value: "FNFG", label: "Generated" },
        { value: "WP", label: "Pending" },
      ],
    },
    // {
    //   title: "Booking Status",
    //   type: "booking",
    //   options: [
    //     { value: "CB", label: "Cancelled Booking" },
    //     { value: "MO", label: "Moved Out" },
    //   ],
    // },
  ];

  useEffect(() => {
    if (currentFilter) {
      let foundFilter = null;
      filterGroups.forEach(group => {
        group.options.forEach(option => {
          if (option.value === currentFilter) {
            foundFilter = {
              type: group.type,
              value: option.value,
              label: option.label
            };
          }
        });
      });
      setSelectedFilter(foundFilter);
    } else {
      setSelectedFilter(null);
    }
  }, [currentFilter]);

  const handleApplyFilter = () => {
    if (selectedFilter) {
      onApplyFilter(selectedFilter.value, selectedFilter.label, selectedFilter.type);
    } else {
      toast.error("Please select at least one filter before applying.");
    }
  };

  useEffect(() => {
    const handleResize = () => {
      setHeight(window.innerHeight)
    }
    window.addEventListener("resize", handleResize)
    handleResize()
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  const handleFilterSelect = (filterType, option) => {
    if (selectedFilter?.value === option.value) {
      setSelectedFilter(null);
    } else {
      setSelectedFilter({
        type: filterType,
        value: option.value,
        label: option.label
      });
    }
  };

  const handleClearAll = () => {
    setSelectedFilter(null);
    if (handleClearFilters) {
      handleClearFilters();
    }
    handleClose();
  };

  return (
    <Container style={{ height: `${height}px`, overflow: "auto", WebkitOverflowScrolling: "touch" }}>
      <ModalHeader>
        <h1 className="text-lg font-medium text-white">Filters</h1>
        <button onClick={handleClose}>
          <MdClose color="white" size={24} />
        </button>
      </ModalHeader>
      <div className="custom-scrollbar flex h-full flex-col justify-between px-4">
        <ScrollableContent className="max-h-[calc(100vh-140px)] overflow-y-auto mt-4">
          {filterGroups.map((group) => (
            <FilterGroup key={group.title}>
              <FilterTitle>{group.title}</FilterTitle>
              <FilterOptions>
                {group.options.map((option) => {
                  const isActive = selectedFilter?.value === option.value;
                  return (
                    <FilterOption
                      key={option.value}
                      active={isActive}
                      onClick={() => handleFilterSelect(group.type, option)}
                    >
                      {option.label}
                    </FilterOption>
                  );
                })}
              </FilterOptions>
            </FilterGroup>
          ))}

        </ScrollableContent>
        <ActionSection>
          <SideCancelBtn
            type="button"
            onClick={handleClearAll}
            hasFilter={!!selectedFilter}
          >
            {selectedFilter ? "Clear Filter" : "Cancel"}
          </SideCancelBtn>
          <SubmitBtn type="submit" onClick={handleApplyFilter}>
            Apply Filter
          </SubmitBtn>
        </ActionSection>
      </div>
    </Container>
  )
}

const Container = tw.div`bg-white w-full h-full flex flex-col relative`
const Header = tw.div`flex items-center justify-between bg-primary-color py-4 px-4`
const FilterGroup = tw.div`mb-4 p-4 bg-gray-50`;
const FilterTitle = tw.h3`text-md font-medium text-gray-800 mb-2`;
const FilterOptions = tw.div`flex flex-wrap gap-2 mt-2`;
const FilterOption = tw.button`px-3 py-1.5 text-sm rounded-full border transition-colors duration-200 ${({ active }) => active ? "border-primary-color bg-primary-color/10 text-primary-color" : "bg-white border-gray-300 text-gray-700 hover:border-gray-400"}`;

export default FilterModalForInActive